function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Alert, Spin, Button, Select, Space, Divider } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditUser = function EditUser(_ref) {
  var handleUpdate = _ref.handleUpdate,
    user = _ref.user;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormPrecessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataLoading = _useState8[0],
    setIsDataLoading = _useState8[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    var formData = new FormData();
    formData.append("id", user.id.toString());
    formData.append('prenom', values.prenom);
    formData.append('user_id', Common.currentUser.id);
    formData.append('nom', values.nom);
    formData.append('email', values.email);
    formData.append('job', values.job);
    formData.append('role', values.role);
    axios.post(Common.baseApiUrl + 'edituser', formData).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    form.setFieldsValue({
      role: user.role,
      job: user.job,
      email: user.email,
      prenom: user.prenom,
      nom: user.nom
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          showIcon: true
        })
      }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "role",
        label: "Role",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: [{
            value: 101,
            label: "Super Manager"
          }, {
            value: 201,
            label: "Responsable de formation"
          }, {
            value: 301,
            label: "Assistante de Direction"
          }, {
            value: 401,
            label: "Comptable"
          }, {
            value: 501,
            label: "Secrétaire Caissière"
          }, {
            value: 601,
            label: "Commercial(e)"
          }, {
            value: 701,
            label: "Formateur employé"
          }, {
            value: 801,
            label: "Formateur Indépendant"
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "job",
        label: "Fonction",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email",
        label: "E-mail",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "prenom",
        label: "Pr\xE9nom",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "nom",
        label: "Nom",
        rules: [{
          required: true,
          message: 'Ce champ est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormPrecessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "METTRE A JOUR"
          })
        })
      })]
    })]
  });
};
export default EditUser;